
import api from '@/api/dy/courseContent/createClass.js'
const state = {
	classList: {
		list: [],
		total: 0
	},
	cateList: [],
	detailSingleClass: {},
	saveId: ''
}
const mutations = {
	classListState(state, data) {
		state.classList = {
			list: data.list,
			total: data.page_info.total_count
		}
	},
	getCateList(state, data) {
		state.cateList = data
	},
	singleproductState(state, data) {
		state.saveId = data.id
	},
	singleindexState(state, data) {
		state.detailSingleClass = data
	}
}
const actions = {
	getClassList({ commit }, params = {}) {
		api.createClassApi(params, (res) => {
			commit('classListState', res)
		})
	},
	getCateList({ commit }, params = {}) {
		api.cateListApi(params, (res) => {
			commit('getCateList', res)
		})
	},
	async singleproduct({commit}, params = {}) {
		try {
			let res = await api.singleproduct(params)
			commit('singleproductState', res)
			return 'success'
		} catch (error) {
			return 'error'
		}
	},
	singleindex({commit}, params = {}) {
		api.singleindex(params, (res) => {
			commit('singleindexState', res)
		})
	},
	async productrecall({commit}, params= {}) {
		try {
			let res = await api.productrecall(params)
			return 'success'
		} catch (error) {
			return 'error'
		}
	},
	async getpdfUrl({commit}, params = {}) {
		let res = await api.getpdf(params)
		return res
	},
	async uprightsdesc({commit}, params = {}) {
		let res = await api.uprightsdesc(params)
		return res
	},
	async userGetCode({}, params = {}) {
		let res = await api.userGetCode(params)
		return res
	}
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}